export default "__VITE_ASSET__CLeYwl7$__"